import axiosClient from 'apis/setup/axiosClient';
import axios from 'axios';
import { toastError } from 'utils/constants/functions';

export interface TDownLoadTemplate {
  fileName: string;
  importId: string;
}

export const UploadApi = {
  // upload: async (formData: FormData) => {
  //   try {
  //     const response = await axiosClient.post(
  //       `${process.env.REACT_APP_API_BASE_URL}/import/upload` as string,
  //       formData,
  //       {
  //         headers: {
  //           'Content-Type': 'multipart/form-data',
  //         },
  //       },
  //     );

  //     return response;
  //   } catch (err) {
  //     console.log(err);
  //   }
  // },
  downloadTemplate: async ({ fileName, importId }: TDownLoadTemplate) => {
    try {
      // const response = await axios({
      //   url: url,
      //   method: 'POST',
      //   responseType: 'blob',
      // });
      const response = await axiosClient.post(
        `import/downloadTemplate/${importId}`,
        {},
        { responseType: 'blob' },
      );

      console.log(response);

      const blob = new Blob([response as any], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const objectURL = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = objectURL;
      a.download = fileName;

      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      window.URL.revokeObjectURL(objectURL);
    } catch (error) {
      console.error(error);
      toastError('Tải file mẫu không thành công');
    }
  },
};
